import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Compares two model ids that may arrive as numbers, strings (bigint PKs are
 * serialized to the frontend as strings) or bigints. Returns false when either
 * side is null/undefined.
 */
export function sameId(
  left: number | string | bigint | null | undefined,
  right: number | string | bigint | null | undefined,
): boolean {
  if (left === null || left === undefined || right === null || right === undefined) {
    return false;
  }

  return Number(left) === Number(right);
}
